<div #container class="ui-control-container" [class.full-window]="fullWindow()" [style.height.px]="fullWindow() ? null : fillHeight()" [style.flex]="!fullWindow() && fillHeight() ? 'none' : null">
    @if (!fullWindow()) {
    <div class="toolbar">
        @if (showRoomSelect()) {
        <p-select class="room-select" [options]="roomOptions()" optionLabel="name" optionValue="value" [ngModel]="selectedRoomId()" (ngModelChange)="onRoomChange($event)" placeholder="Default room" [showClear]="true" size="small" />
        }
        <p-button label="Open Full Screen" icon="fa-solid fa-expand" size="small" [outlined]="true" [disabled]="roomMappingMissing()" (onClick)="openFullScreen()" />
    </div>
    } @else {
    <div class="floating-controls">
        @if (showRoomSelect()) {
        <p-select class="room-select" [options]="roomOptions()" optionLabel="name" optionValue="value" [ngModel]="selectedRoomId()" (ngModelChange)="onRoomChange($event)" placeholder="Default room" [showClear]="true" size="small" />
        }
        <p-button icon="fa-solid fa-xmark" severity="secondary" [rounded]="true" ariaLabel="Close full screen" (onClick)="closeFullScreen()" />
    </div>
    } @if (iframeSrc() && panelReady()) {
    <iframe #panelFrame class="grow" [src]="iframeSrc()" [title]="t()('room.uiControl')"></iframe>
    } @else if (showOfflinePlaceholder()) {
    <div class="placeholder">
        <i class="fa-solid fa-plug-circle-xmark"></i>
        <p>Device tunnel is offline — the touch panel UI is unavailable.</p>
        <p-button label="Retry" icon="fa-solid fa-rotate" size="small" (onClick)="retry()" />
    </div>
    } @else if (sessionError()) {
    <div class="placeholder">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <p>{{ sessionError() }}</p>
        <p-button label="Retry" icon="fa-solid fa-rotate" size="small" (onClick)="retry()" />
    </div>
    } @else if (roomMappingMissing() && roomsLoaded()) {
    <div class="placeholder" role="status">
        <i class="fa-solid fa-door-closed" aria-hidden="true"></i>
        <p>{{ t()(roomLoadError() ? 'room.loadError' : 'room.controlUnavailable') }}</p>
        @if (!roomLoadError()) {
        <p class="placeholder-subtext">{{ t()('room.mappingUnavailable') }}</p>
        }
        <p-button label="Retry" icon="fa-solid fa-rotate" size="small" (onClick)="retry()" />
    </div>
    } @else if (probeTimedOut()) {
    <div class="placeholder">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <p>The device is taking longer than expected to start its touch panel UI.</p>
        <p-button label="Retry" icon="fa-solid fa-rotate" size="small" (onClick)="retry()" />
    </div>
    } @else if (probing()) {
    <div class="placeholder">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Device is getting ready…</p>
        <p class="placeholder-subtext">The touch panel UI is starting up on the device. This can take a minute after a reboot.</p>
    </div>
    } @else {
    <div class="placeholder">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Connecting to device…</p>
    </div>
    }
</div>
